// Docs: https://developers.google.com/maps/documentation/maps-static/start
const MAP_PREFIX = "https://maps.googleapis.com/maps/api/staticmap";

export const getGoogleStaticMapSrc = (
  coordinates: { lat: number; lon: number },
  zoom: number,
  size: { width: number; height: number },
  scale = 1,
  showMarker = false,
  markerColor = "red",
  markerIcon: string | undefined = undefined,
  apiKey: string | undefined = import.meta.env
    .VITE_REACT_APP_GOOGLE_MAPS_API_KEY
) => {
  const coordinatesString = `${coordinates.lat},${coordinates.lon}`;
  const marker = showMarker
    ? `&markers=${markerIcon ? `icon:${markerIcon}` : `color:${markerColor}`}|${coordinatesString}`
    : "";
  return `${MAP_PREFIX}?center=${coordinatesString}&zoom=${zoom}&size=${
    size.width
  }x${size.height}&scale=${scale}${marker}&maptype=roadmap&key=${apiKey}`;
};
